import {  MAT_DIALOG_DATA,MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  Component,
  ViewEncapsulation,
  ViewChild,
  OnInit,
  ChangeDetectorRef,
  Inject,
  ElementRef
} from '@angular/core';
import Swiper, { SwiperOptions } from 'swiper';
import { TrackingItemRefundCodConsent } from '../tracking-item-refund-cod-consent/tracking-item-refund-cod-consent';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { interval, Subject, Observable, Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { refund_cod_response_model } from '../tracking-item-refund-cod-dialog/tracking-item-refund-cod-model';
import { refund_cod_request_model } from '../tracking-item-refund-cod-dialog/tracking-item-refund-cod-model';
@Component({
  selector: 'kett-refund-cod-form',
  templateUrl: 'tracking-item-refund-cod-dialog.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls :['tracking-item-refund-cod-dialog.css']
})


 export class TrackingItemRefundCodDialog implements OnInit {
  form: FormGroup;
  refundForm: FormGroup;
  evidenceFiles: any[] = [];
  idCardFiles: any[] = [];
  nameChangeFiles: any[] = [];
  companyCertificationFiles: any[] = [];
  powerOfAttorneyFiles: any[] = [];
  bankAccountFiles: any[] = [];
  evidenceImageUrls: string[] = [];
  idCardImageUrls: string[] = [];
  nameChangeImageUrls: string[] = [];
  companyCertificationImageUrls: string[] = [];
  powerOfAttorneyImageUrls: string[] = [];
  bankAccountImageUrls: string[] = [];
  refundReason: { value: string; display: string }[] = [];
  file: any = {};
  //sanitizedPreview: SafeResourceUrl;
  safePreviewUrl: SafeResourceUrl | null = null;
  imagePreview: string | ArrayBuffer | null = null;
  // refundData = {
  //   consignmentNumber: '',
  //   refundReason: '',
  //   identityType: '',
  //   identityNumber: '',
  //   nameSurname: '',
  //   phoneNumber: '',
  //   email: '',
  //   address: '',
  //   postalCode: '',
  //   bank: '',
  //   bankAccountNumber: '',
  //   accountName: '',
  //   agreeTerms: false
  // };
  
  constructor(private formBuilder: FormBuilder, private _HttpClient: HttpClient, private sanitizer: DomSanitizer) {
    this.refundForm = this.formBuilder.group({
      consignmentNumber: ['', Validators.required],
      refundReason: ['', Validators.required],
      identityType: ['', Validators.required],
      identityNumber: ['', Validators.required],
      nameSurname: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      address: ['', Validators.required],
      postalCode: ['', Validators.required],
      branchCode: [''],
      taxId: [''],
      companyName: [''],
      bank: ['', Validators.required],
      bankAccountNumber: ['', Validators.required],
      accountName: ['', Validators.required],
      agreeTerms: [false, Validators.requiredTrue]
    });
  }
    ngOnInit(): void {
      this.refundForm.get('companyType')?.valueChanges.subscribe(value => {
        this.onCompanyTypeChange(value);
      });

      this.refundReason = [
        { value: '0', display: 'Did not order' },
        { value: '1', display: 'Product does not match with order' },
        { value: '2', display: 'Defective products' }
      ];

      // const dialogRef = this.dialog.open(TrackingItemRefundCodConsent, {
      //   //data: { data: shipment, isVerify: true },
      //   height: 'auto',
      //   width: '600px',
      // });
    }

    onFileChange(event: any, type: string) {
      const files = event.target.files;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      // Check if the file is already selected
      if(this.checkFileUpload(type, file.name)){
      //if (!this.evidenceFiles.some(f => f.name === file.name)) {
        const reader = new FileReader();
        
        // When file is loaded, store the preview
        reader.onload = (e: any) => {
          const filePreview = {
            name: file.name,
            size: file.size,
            type: file.type,
            file: file,  // store the actual file object
            preview: e.target.result,  // base64 image preview
            uploaded: false,
            uploadError: null
          };

           // Sanitize the URL if the file is a PDF
           if (file.type === 'application/pdf') {
            this.safePreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(e.target.result);
            this.imagePreview = 'assets/pdf-placeholder.png';
          } else {
            filePreview.preview = e.target.result;
            this.imagePreview = e.target.result;
          }
          //this.evidenceFiles.push(filePreview);
          this.pushFileUpload(filePreview, type);
          // Upload the file immediately after preview is generated
          this.uploadFile(filePreview, type);
          
        };
        // Read the file as data URL to show the preview
        reader.readAsDataURL(file);
      }
    }
  }

  checkFileUpload(type:string, fileName:string){
    console.log('checkFileUpload type => ' + type);
    console.log('checkFileUpload fileName => ' + fileName);
    switch(type)
    {
      case "evidence": return !this.evidenceFiles.some(f => f.name === fileName) ? true : false;
      case "idCard": return  !this.idCardFiles.some(f => f.name === fileName) ? true : false; 
      case "nameChange": return  !this.nameChangeFiles.some(f => f.name === fileName) ? true : false; 
      case "companyCertification": return  !this.companyCertificationFiles.some(f => f.name === fileName) ? true : false; 
      case "powerOfAttorney": return  !this.powerOfAttorneyFiles.some(f => f.name === fileName) ? true : false; 
      case "bankAccount": return  !this.bankAccountFiles.some(f => f.name === fileName) ? true : false; 
    }
  }

  pushFileUpload(filePreview: any, type:string){
    switch(type)
    {
      case "evidence": return this.evidenceFiles.push(filePreview);
      case "idCard": return this.idCardFiles.push(filePreview);
      case "nameChange": return this.nameChangeFiles.push(filePreview);
      case "companyCertification": return this.companyCertificationFiles.push(filePreview);
      case "powerOfAttorney": return this.powerOfAttorneyFiles.push(filePreview);
      case "bankAccount": return this.bankAccountFiles.push(filePreview);
    }
  }

  pushImageUrls(filePreview: any, type:string){
    switch(type)
    {
      case "evidence": return this.evidenceImageUrls.push(filePreview);
      case "idCard": return this.idCardImageUrls.push(filePreview);
      case "nameChange": return this.nameChangeImageUrls.push(filePreview);
      case "companyCertification": return this.companyCertificationImageUrls.push(filePreview);
      case "powerOfAttorney": return this.powerOfAttorneyImageUrls.push(filePreview);
      case "bankAccount": return this.bankAccountImageUrls.push(filePreview);
    }
  }

  uploadFile(filePreview: any,type:string) {
    const uploadURL = 'http://10.112.85.112:6950/api/Media/media_upload_bypass'; // Replace with your backend API URL
    const formData = new FormData();
    formData.append('fileDetail', filePreview.file);  // Append the actual file

    // Send POST request to upload the file
    this._HttpClient.post(uploadURL, formData).subscribe(
      (response: any) => {
        console.log(response);
        filePreview.fileUrl = response.mediaUrl;  // Store the file URL from the response
        //this.evidenceImageUrls.push(filePreview.fileUrl);  // Mark the file as uploaded on success
        this.pushImageUrls(filePreview.fileUrl, type);
      },
      (error) => {
        filePreview.uploadError = 'Upload failed';  // Handle the error case
        console.error('Upload error', error);
      }
    );
  }

  removeImage(index: number, type: string) {
    switch(type)
    {
      case "evidence": {
          const fileUrlToRemove = this.evidenceFiles[index]?.fileUrl;
            if (fileUrlToRemove) {
            this.evidenceImageUrls = this.evidenceImageUrls.filter(url => url !== fileUrlToRemove);
            this.evidenceFiles.splice(index, 1);
            }
        break;
      }
      case "idCard": {
        const fileUrlToRemove = this.idCardFiles[index]?.fileUrl;
            if (fileUrlToRemove) {
            this.idCardImageUrls = this.idCardImageUrls.filter(url => url !== fileUrlToRemove);
            this.idCardFiles.splice(index, 1);
            }
        break;
      }
      case "nameChange": {
        const fileUrlToRemove = this.nameChangeFiles[index]?.fileUrl;
            if (fileUrlToRemove) {
            this.nameChangeImageUrls = this.nameChangeImageUrls.filter(url => url !== fileUrlToRemove);
            this.nameChangeFiles.splice(index, 1);
            }
        break;
      }
      case "companyCertification": {
        const fileUrlToRemove = this.companyCertificationFiles[index]?.fileUrl;
            if (fileUrlToRemove) {
            this.companyCertificationImageUrls = this.companyCertificationImageUrls.filter(url => url !== fileUrlToRemove);
            this.companyCertificationFiles.splice(index, 1);
            }
        break;
      }
      case "powerOfAttorney":{
        const fileUrlToRemove = this.powerOfAttorneyFiles[index]?.fileUrl;
            if (fileUrlToRemove) {
            this.powerOfAttorneyImageUrls = this.powerOfAttorneyImageUrls.filter(url => url !== fileUrlToRemove);
            this.powerOfAttorneyFiles.splice(index, 1);
            }
        break;
      }
      case "bankAccount": {
        const fileUrlToRemove = this.bankAccountFiles[index]?.fileUrl;
            if (fileUrlToRemove) {
            this.bankAccountImageUrls = this.bankAccountImageUrls.filter(url => url !== fileUrlToRemove);
            this.bankAccountFiles.splice(index, 1);
            }
        break;
      }
    }
  }
  
  getImageUrlsString(type: string): string {
    switch(type)
    {
      case "evidence": return this.evidenceImageUrls.join(',');
      case "idCard": return this.idCardImageUrls.join(',');
      case "nameChange": return this.nameChangeImageUrls.join(',');
      case "companyCertification": return this.companyCertificationImageUrls.join(',');
      case "powerOfAttorney": return this.powerOfAttorneyImageUrls.join(',');
      case "bankAccount": return this.bankAccountImageUrls.join(',');
    }
  }

  onCompanyTypeChange(value: string): void {
    if (value === 'branchType') {
      this.refundForm.get('branchCode')?.setValue(''); // or any logic you want
    }
  }

    submitRequest() {
      console.log('RefundForm => ' + this.refundForm.invalid);
      console.log(this.refundForm.value);
      // if (this.refundForm.invalid) {
      //   this.refundForm.markAllAsTouched(); // Marks all controls as touched to show validation errors
      //   alert('Please complete the form and upload the required file.');
      //   return;
      // }
      if (this.refundForm.valid) {
        this.CallToKOP(this.refundForm.value).subscribe(response => {
          console.log('API Response:', response);
        });
    }
  }

    CallToKOP(refundForm: any): Observable<refund_cod_response_model> {
      // Map form values to refund_cod_request_model
      console.log('========= CallToKOP ==========')
      const requestData: refund_cod_request_model = {
        consignment_no: refundForm.consignmentNumber,
        refund_reason: refundForm.refundReason,
        buyer_type: refundForm.identityType, // Assuming this represents the buyer type
        buyer_personal: {
          identity_type: refundForm.identityType,
          id_card_no: refundForm.identityNumber,
          name_surname: refundForm.nameSurname,
          phone_number: refundForm.phoneNumber,
          email: refundForm.email,
          address_detail: refundForm.address,
          sub_district: '', // Add values if available in form
          district: '', // Add values if available in form
          province: '', // Add values if available in form
          postal_code: refundForm.postalCode,
        },
        bank_account: {
          bank_name: refundForm.bank,
          bank_account_no: refundForm.bankAccountNumber,
          account_name: refundForm.accountName,
        },
        buyer_accept: {
          consent_accept: refundForm.agreeTerms ? 1 : 0,
          terms_condition_accept: refundForm.agreeTerms ? 1 : 0,
          privacy_accept: refundForm.agreeTerms ? 1 : 0,
        },
        buyer_company:{
          company_type:refundForm.companyType,
          branch_code:refundForm.branchCode,
          tax_id:refundForm.taxId,
          company_name:refundForm.companyName,
          phone_number:refundForm.phoneNumber,
          email:refundForm.email,
          address_detail:refundForm.address,
          sub_district: '', // Add values if available in form
          district: '', // Add values if available in form
          province: '', // Add values if available in form
          postal_code: refundForm.postalCode,
        },
        media_attached:{
          evidence:this.evidenceImageUrls,
          id_card:this.idCardImageUrls,
          name_change:this.nameChangeImageUrls,
          company_certification:this.companyCertificationImageUrls,
          power_of_attorney:this.powerOfAttorneyImageUrls,
          bank_account:this.bankAccountImageUrls
        }
      };
  console.log('Request=> ' + JSON.stringify(requestData));
      // Call the API
      return this._HttpClient.post<refund_cod_response_model>(window.location.href, requestData);
    }
    
 }